import api from "app/lib/api";
import { BASE_URL } from "static/constants";

export const getCommunicationLogs = async (patientId) => {
  if (patientId) {
    const url = `${BASE_URL}/v2/patient-communication-logs/patient/${patientId}`;
    const { data } = await api.get(url);

    return data;
  }
};

export const upsertCommunicationLog = async (
  patientId,
  communicationLog,
  isEditAction
) => {
  if (patientId) {
    let response;

    const payload = {
      patient_id: patientId,
      communicated_date: communicationLog?.communicated_date,
      description: communicationLog?.description,
      duration: communicationLog?.duration,
      mode:
        communicationLog?.mode === "Other"
          ? communicationLog?.customMode
          : communicationLog?.mode,
    };

    if (isEditAction) {
      const id = communicationLog?._id;
      const { _id, ...rest } = payload;
      response = await api.put(
        `${BASE_URL}/v2/patient-communication-logs/${id}`,
        rest
      );
    } else {
      response = await api.post(
        `${BASE_URL}/v2/patient-communication-logs`,
        payload
      );
    }

    return response;
  }
};

export const deleteCommunicationLog = async (id) => {
  if (id) {
    const url = `${BASE_URL}/v2/patient-communication-logs/${id}`;
    const data = await api.delete(url);

    return data;
  }
};

export const downloadLateRpm = async (account) => {
  let url = `${BASE_URL}/v2/rpm/download-late-rpm/${account}`;

  if (account) {
    return await api(url, {
      method: "POST",
      responseType: "blob",
    });
  }
};

export const downloadRpmBillingHistory = async (payload) => {
  let url = `${BASE_URL}/v2/rpm/download-rpm-billing`;

  if (payload) {
    const response = await api(url, {
      method: "POST",
      responseType: "blob",
      data: payload,
    });

    return response;
  }
};

export const updateBPChartViewStatus = async (patientId, payload) => {
  const url = `${BASE_URL}/v2/rpm/bp-reading-history/${patientId}`;

  const response = await api.put(url, payload);

  return response;
};

export const weightScale = async (patientId) => {
  const url = `${BASE_URL}/v2/rpm/${patientId}/scale-reading`;
  const { data } = await api.get(url);

  return data;
};
